import axios from 'axios';
import { jwtService } from './jwt.service';
import WebApp from '@twa-dev/sdk';

jwtService.initToken();

const ApiClient = axios.create({
    baseURL: process.env.REACT_APP_API_ENDPOINT,
    withCredentials: true,
    headers: {
        Authorization: process.env.NODE_ENV === 'development' ? 'Bearer ' + jwtService.getToken() : WebApp.initData,
    },
});

export { ApiClient };
